import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingSearchReportRecord = Record({
  id: 0,
  createdAt: 0,
});

export default class FundingSearchReportModel extends FundingSearchReportRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      createdAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingSearchReportModel(hydrated);
  }
}
